export default function PageHeader({ eyebrow, title, subtitle, action }) {
    return (
        <header className="flex items-start justify-between gap-6 flex-wrap">
            <div>
                <div className="caption">{eyebrow}</div>
                <h1 className="font-serif text-3xl sm:text-4xl mt-2 tracking-tight">{title}</h1>
                {subtitle && <p className="text-sm text-zinc-500 mt-2 max-w-2xl leading-relaxed">{subtitle}</p>}
            </div>
            {action}
        </header>
    );
}
